// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-container[data-v-53e6d79b]{border-radius:16px;box-shadow:0 8px 50px 0 rgba(0,0,0,.04);padding:15px}.card-header[data-v-53e6d79b],.card-text[data-v-53e6d79b]{color:#000;margin-top:30px}.card-image[data-v-53e6d79b]{margin:30px auto;width:50%}", ""]);
// Exports
module.exports = exports;
